export default __webpack_public_path__ + "static/media/pressRoom.9ca646ce.png";